import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import { couponRestApi } from '../config';
import { Divider, Paper, Toolbar, ToolbarGroup, ToolbarTitle, IconButton, RaisedButton, LinearProgress } from 'material-ui';
import { Field, reduxForm } from 'redux-form';
import { TextField, DatePicker } from 'redux-form-material-ui';
import NavigationRefresh from 'material-ui/svg-icons/navigation/refresh';
import CreateCouponBlock from './CreateBlockDefinition';
import CreateAllocationBlock from './CreateBlockAllocation';
import BlockCard from './BlockCard';
import { hasRoles } from '../api/userApi';
import { grey600 } from 'material-ui/styles/colors';
import { numberFormat } from '../filters';
import CouponBreadCrumbs from "./CouponBreadcrumbs";

export const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Please enter a Coupon Name'
  }
  if (!values.description) {
    errors.description = 'Please enter a description'
  }
  if (!values.prefix) {
    errors.prefix = 'Required'
  }
  if (!values.startsOn) {
    errors.startsOn = 'Required';
  }
  if (!values.endsOn) {
    errors.endsOn = 'Required'
  } else if (values.startsOn >= values.endsOn) {
    errors.endsOn = 'Please enter a date later than the start date'
  }
  return errors
};

const styles = {
  section: {
    marginBottom: '20px'
  },
  buttonMargin: {
    margin: "10px"
  }
};

export class EditCouponForm extends Component {
  constructor(props) {
    super(props);
    this.putUpdates = this.putUpdates.bind(this);
  }

  putUpdates(body) {
    return (
      couponRestApi.put('/coupons/' + this.props.coupon.id, body).then((response) => {
        this.props.onRefresh && this.props.onRefresh();
      }).catch((error) => {
        console.log("Post coupon failed: " + error);
      })
    )
  }

  render() {
    const { handleSubmit, pristine, reset } = this.props;
    const canUpdate = hasRoles('write:coupons');
    return (
        <Col xs={12}>
          <form onSubmit={handleSubmit(this.putUpdates)}>
          <Paper zDepth={1}>
            <Toolbar>
              <ToolbarGroup>
                <ToolbarTitle text="Coupon Details" style={{fontSize: "1rem"}}/>
              </ToolbarGroup>
            </Toolbar>
            <Row style={{ padding:"20px" }}>
              <Col xs={12} sm={6}>
                <Field
                  id="couponName"
                  name="name"
                  component={TextField}
                  fullWidth={true}
                  floatingLabelText="Coupon Name"
                  onChange={this.handleFieldUpdate}
                  underlineDisabledStyle={{border:'none'}}
                  disabled={!canUpdate}
                />
              </Col>
              <Col xs={12} sm={6} md={3}>
                <Field
                  id="couponPrefix"
                  name="prefix"
                  component={TextField}
                  fullWidth={true}
                  floatingLabelText="Coupon Prefix"
                  onChange={this.handleFieldUpdate}
                  underlineDisabledStyle={{border:'none'}}
                  disabled={true}
                />
              </Col>
              <Col xs={12} sm={6} md={3}>
                <Field
                  id="couponType"
                  name="type"
                  component={TextField}
                  fullWidth={true}
                  floatingLabelText="Coupon Type"
                  onChange={this.handleFieldUpdate}
                  underlineDisabledStyle={{border:'none'}}
                  disabled={true}
                />
              </Col>
              <Col xs={12} md={6}>
                <Field
                  id="couponDesc"
                  name="description"
                  component={TextField}
                  fullWidth={true}
                  multiLine={true}
                  floatingLabelText="Coupon Description"
                  onChange={this.handleFieldUpdate}
                  underlineDisabledStyle={{border:'none'}}
                  disabled={!canUpdate}
                />
              </Col>
              <Col xs={12} sm={6} md={3}>
                <Field
                  id="couponStart"
                  name="startsOn"
                  component={DatePicker}
                  hintText="Start Date"
                  fullWidth={true}
                  floatingLabelText="Start Date"
                  underlineDisabledStyle={{border:'none'}}
                  disabled={!canUpdate}
                />
              </Col>
              <Col xs={12} sm={6} md={3}>
                <Field
                  id="couponEnd"
                  name="endsOn"
                  component={DatePicker}
                  hintText="Start Date"
                  fullWidth={true}
                  floatingLabelText="Expiration Date"
                  underlineDisabledStyle={{border:'none'}}
                  disabled={!canUpdate}
                />
              </Col>
              <Col xs={12}>
                { (canUpdate && !pristine) &&
                <div>
                  <RaisedButton style={styles.buttonMargin} primary={true} disabled={pristine} label="Save Changes" type="submit" />
                  <RaisedButton style={styles.buttonMargin} disabled={pristine} label="Reset Changes" onClick={reset} />
                </div>
                }
              </Col>
            </Row>
          </Paper>
          </form>
        </Col>
    );
  }
}

// Decorate EditCouponForm with reduxForm

EditCouponForm = reduxForm({
  form: 'EditCouponForm',
  validate,
  enableReinitialize: true
})(EditCouponForm);

export const CouponStats = ({ coupon, onRefresh }) => (
    <Paper style={{padding: '20px'}} zDepth={1}>
      <h4>
        Coupon Statistics
      </h4>
      <Divider/>
      <p><small>Codes Generated</small></p>
      <h3>{!!coupon.statistics ? numberFormat(coupon.statistics.numCodesDefined) : '0'}</h3>
      <Divider />
      <p><small>Codes Assigned</small></p>
      <h3>{!!coupon.statistics ? numberFormat(coupon.statistics.numCodesAllocated) : '0'}</h3>
      <LinearProgress style={{height: '15px'}} mode="determinate" max={coupon.statistics.numCodesDefined} value={coupon.statistics.numCodesAllocated}/>
      <p><small><i>({!!coupon.statistics ? numberFormat(coupon.statistics.numCodesDefined - coupon.statistics.numCodesAllocated) : '0'} Codes Remaining)</i></small></p>
    </Paper>
);

export const CouponBlockList = ({ couponBlocks, isDefinition, onRefresh }) => {

  const CouponBlockRows = ( block ) => {
    return (
      <Col key={block.id} xs={12} md={6} lg={4}>
        <BlockCard
          status={block.status}
          id={block.id}
          createdBy={block.createdBy}
          requestedBy={block.requestedBy}
          issueId={block.issueId}
          description={block.description}
          numCodes={block.numCodes}
          isDefinition={isDefinition}
          dateCreated={block.createdOn}
          onRefresh={onRefresh}
        />
      </Col>
    );
  };

  let blocks = [];

  if (isDefinition) {
    blocks = couponBlocks.map(CouponBlockRows);
  }
  else {
    blocks = couponBlocks.map(CouponBlockRows);
  }

  return (
    <Row>
      {blocks}
    </Row>
  );
};

export const CouponDetail = ({ onRefresh, coupon, definitionBlocks, allocationBlocks }) => (
  <div>
    {/*{ coupon &&*/}
    {/*<PageHeader>{coupon ? coupon.name : ""}</PageHeader>*/}
    {/*}*/}
    { coupon &&
      <Row>
        <Col xs={12}>
          <CouponBreadCrumbs coupon={coupon}/>
        </Col>
      </Row>
    }
    <Row>
      <Col xs={12} sm={9}>
        { coupon &&
          <Row style={styles.section}>
            <EditCouponForm initialValues={coupon} coupon={coupon} onRefresh={onRefresh}/>
          </Row>
        }
        { (coupon && definitionBlocks) &&
        <Row style={styles.section}>
          <Col xs={12}>
            <Paper>
              <Toolbar>
                <ToolbarGroup firstChild={false}>
                  <ToolbarTitle text="Generated Codes" style={{fontSize: "1rem"}}/>
                </ToolbarGroup>
                <ToolbarGroup lastChild={true}>
                  { hasRoles('define:coupons') &&
                    <CreateCouponBlock color={ grey600 } title="Add" couponId={coupon.id} onRefresh={onRefresh}/>
                  }
                  <IconButton tooltip="Refresh" onClick={onRefresh}>
                    <NavigationRefresh color={ grey600 } />
                  </IconButton>
                </ToolbarGroup>
              </Toolbar>
            </Paper>
            <CouponBlockList coupon={coupon} couponBlocks={definitionBlocks} isDefinition={true} onRefresh={onRefresh}/>
          </Col>
        </Row>
        }
        { (coupon && allocationBlocks) &&
        <Row style={styles.section}>
          <Col xs={12}>
            <Paper>
              <Toolbar>
                <ToolbarGroup firstChild={false}>
                  <ToolbarTitle text="Assigned Codes" style={{fontSize: "1rem"}}/>
                </ToolbarGroup>
                <ToolbarGroup lastChild={true}>
                  { hasRoles('allocate:coupons') &&
                    <CreateAllocationBlock codesAvailable={coupon.statistics.numCodesDefined - coupon.statistics.numCodesAllocated} color={ grey600 } title="Add" couponId={coupon.id} onRefresh={onRefresh}/>
                  }
                  <IconButton tooltip="Refresh" onClick={onRefresh}>
                    <NavigationRefresh color={ grey600 } />
                  </IconButton>
                </ToolbarGroup>
              </Toolbar>
            </Paper>
            <CouponBlockList coupon={coupon} couponBlocks={allocationBlocks} isDefinition={false} onRefresh={onRefresh}/>
          </Col>
        </Row>
        }
      </Col>
      <Col xs={12} sm={3}>
        <Row>
          <Col xs={12}>
            { coupon &&
              <CouponStats coupon={coupon}/>
            }
          </Col>
        </Row>
      </Col>
    </Row>
  </div>
);

class CouponContainer extends Component {
  constructor(props) {
    super();
    this.state = { couponId: props.match.params.id };
    this.handleRefresh = this.handleRefresh.bind(this);
    this.filterBlocks = this.filterBlocks.bind(this);
  }

  componentDidMount() {
    this.handleRefresh();
  }

  handleRefresh(e){
    this.loadCoupon();
    this.loadBlocks();
  }

  filterBlocks(data) {
    const filterAllocations = (block) => block.type === "allocation";
    let allocationBlocks = data.filter(filterAllocations);

    const filterDefinitions = (block) => block.type === "definition";
    let definitionBlocks = data.filter(filterDefinitions);

    this.setState({
      allocationBlocks,
      definitionBlocks
    });
  }

  loadCoupon() {
    let self = this;
    couponRestApi.get("/coupons/" + this.state.couponId + "?loadStatistics=true").then(({data}) => {
      data.endsOn = new Date(data.endsOn);
      data.startsOn = new Date(data.startsOn);
      self.setState(Object.assign({}, self.state, { coupon: data }));
    }).catch((error) => {
      console.log("Get coupon failed: " + error);
    });
  }

  loadBlocks() {
    couponRestApi.get('/coupons/' + this.state.couponId + '/blocks').then(({data}) => {
      this.filterBlocks(data);
    }).catch((error) => {
      console.log(error);
    });
  }

  render() {
    return (
      <CouponDetail
        onRefresh={this.handleRefresh}
        coupon={this.state.coupon}
        definitionBlocks={this.state.definitionBlocks}
        allocationBlocks={this.state.allocationBlocks}
      />
    );
  }
}

export default CouponContainer;
